import React from 'react';
import { ButtonSecondary, PromptConfirmationModal, SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { FavouriteSectionType } from '../metroline/types';
import { FavouriteSection } from '../types';
import { Icon } from 'ui/common/icon';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { displayScheduleSection } from 'app/area/favourite-administration/form/components/helpers';
import styles from './favourite-schedule.scss';

export const FavouriteScheduledReport: React.FC<FavouriteSection> = ({
  favouriteItem, deleteSchedule, scheduleDeleting, translation, section, getRef, shouldRenderSection,
  setHideRemoveSchedule, hideRemoveSchedule
}) => {

  if (!displayScheduleSection(favouriteItem?.reportType?.value)) {
    return null;
  }

  const iconAbsolutePath = toAbsoluteUrl('i/recurrence.svg');
  const iconSchedule = <Icon url={iconAbsolutePath} />;

  const removeSchedule = () => {
    deleteSchedule(favouriteItem.id, translation.schedule_deleted, setHideRemoveSchedule);
  };

  const hasSchedule = !!favouriteItem?.hasSchedule && !hideRemoveSchedule;

  return <MetroLineSection<FavouriteSectionType>
    section={section}
    sectionType={FavouriteSectionType.Schedule}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(FavouriteSectionType.Schedule)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={FavouriteSectionType.Schedule}
        validation={undefined}
        info={{ text: translation.schedule }}
        label={{ visible: true, text: translation.schedule }} />
      <MainGridContainer>
        <div className="row mb-3">
          <div className="col-12">
            <span className={styles.iconSchedule}>{iconSchedule}</span>
            <span>
              {hasSchedule
                ? translation.scheduled_for_auto_execute
                : translation.not_scheduled_for_auto_execute}
            </span>
          </div>
        </div>
        {hasSchedule
          ? <div className="row mt-1 mb-4">
            <div className="col-12">
              <PromptConfirmationModal
                title={translation.remove_schedule}
                description={translation.remove_schedule_description}
                continueText={translation.remove}
                cancelText={translation.cancel}
                onContinue={removeSchedule}>
                <ButtonSecondary
                  disabled={scheduleDeleting}
                  id="remove_schedule">
                  {translation.remove_schedule}
                </ButtonSecondary>
              </PromptConfirmationModal>
            </div>
          </div> : null}
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
